import React from 'react';
import { CTAButton } from '../components/CTAButton';
import { SectionReveal } from '../components/SectionReveal';
import { MailIcon, SmartphoneIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="oferta" className="relative w-full bg-brand-darker py-20 md:py-28 overflow-hidden" data-id="element-134">
      {/* Dramatic background */}
      <div className="absolute inset-0 bg-gradient-to-b from-brand-dark via-brand-darker to-brand-darker" data-id="element-135" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-500/5 rounded-full blur-3xl" data-id="element-136" />

      <div className="relative z-10 max-w-2xl mx-auto px-4 text-center" data-id="element-137">
        <SectionReveal data-id="element-138">
          <p className="text-4xl mb-4" data-id="element-139">💰</p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-white mb-10 uppercase tracking-[-0.02em]" data-id="element-140">
            Acceso inmediato a la guía completa:
          </h2>
        </SectionReveal>

        <SectionReveal delay={0.1} data-id="element-141">
          <div className="bg-[#1e293b] border-2 border-[rgba(59,130,246,0.4)] rounded-2xl p-8 md:p-12 mb-10 relative overflow-hidden" style={{
          boxShadow: '0 0 40px rgba(59,130,246,0.08)'
        }} data-id="element-142">
            {/* Glowing corner accents */}
            <div className="absolute top-0 left-0 w-20 h-20 bg-[rgba(59,130,246,0.08)] rounded-br-full" data-id="element-143" />
            <div className="absolute bottom-0 right-0 w-20 h-20 bg-[rgba(59,130,246,0.08)] rounded-tl-full" data-id="element-144" />

            {/* Price */}
            <div className="mb-8" data-id="element-145">
              <p className="text-lg text-gray-500 font-body mb-2" data-id="element-146">
                <span className="line-through text-brand-red text-xl" data-id="element-147">
                  antes: $49.990
                </span>
              </p>
              <div className="flex items-baseline justify-center gap-2" data-id="element-148">
                <span className="font-heading font-bold text-6xl sm:text-7xl md:text-8xl text-shimmer" data-id="element-149">
                  $14.999
                </span>
              </div>
              <div className="flex justify-center mt-2 mb-2" data-id="element-150">
                <div className="inline-block rounded-full" style={{
                background: '#00C853',
                color: '#000',
                fontWeight: 800,
                fontSize: '14px',
                padding: '6px 16px',
                borderRadius: '999px',
                margin: '8px 0'
              }} data-id="element-151">
                  ✓ Ahorrás $35.000 hoy —70% OFF
                </div>
              </div>
              <p className="font-body font-semibold mt-4 mb-2 text-[12px] text-[#EEEEEE]" data-id="element-152">
                Guía hecha por electricista matriculado
              </p>
              <p className="text-xl text-blue-400 font-body font-semibold mt-2" data-id="element-153">
                Pago único que{' '}
                <span className="underline decoration-blue-400/60 decoration-2 underline-offset-4" data-id="element-154">
                  recuperas en tu primera factura
                </span>
              </p>
            </div>

            {/* Delivery info */}
            <div className="space-y-4 mb-10" data-id="element-155">
              <div className="flex items-center justify-center gap-3" data-id="element-156">
                <MailIcon className="w-5 h-5 text-blue-400 flex-shrink-0" aria-hidden="true" data-id="element-157" />
                <p className="text-gray-300 font-body text-lg m-0" data-id="element-158">
                  Descarga inmediata después del pago
                </p>
              </div>
              <div className="flex items-center justify-center gap-3" data-id="element-159">
                <SmartphoneIcon className="w-5 h-5 text-blue-400 flex-shrink-0" aria-hidden="true" data-id="element-160" />
                <p className="text-gray-300 font-body text-lg m-0" data-id="element-161">
                  La recibís en tu email al instante
                </p>
              </div>
            </div>

            {/* CTA */}
            <CTAButton text="QUIERO BAJAR MI FACTURA AHORA" size="xl" data-id="element-162" />

            {/* Trust badges */}
            <div className="flex items-center justify-center gap-2 mt-6 text-gray-500" data-id="element-163">
              <ShieldCheckIcon className="w-4 h-4" aria-hidden="true" data-id="element-164" />
              <p className="text-sm font-body m-0" data-id="element-165">
                Compra 100% segura · Acceso inmediato
              </p>
            </div>

            {/* Payment methods */}
            <div className="mt-8 pt-6 border-t border-gray-700/30" data-id="element-166">
              <p className="text-xs text-gray-500 font-body mb-4 uppercase tracking-wider" data-id="element-167">
                Medios de pago
              </p>
              <div className="flex flex-wrap items-center justify-center gap-3" data-id="element-168">
                {[{
                src: 'https://ahorratotal.shop/cdn/shopifycloud/checkout-web/assets/c1/assets/visa.sxIq5Dot.svg',
                alt: 'Visa'
              }, {
                src: 'https://ahorratotal.shop/cdn/shopifycloud/checkout-web/assets/c1/assets/master.CzeoQWmc.svg',
                alt: 'Mastercard'
              }, {
                src: 'https://ahorratotal.shop/cdn/shopifycloud/checkout-web/assets/c1/assets/american_express.C3z4WB9r.svg',
                alt: 'American Express'
              }, {
                src: 'https://ahorratotal.shop/cdn/shopifycloud/checkout-web/assets/c1/assets/diners_club.B9hVEmwz.svg',
                alt: 'Diners Club'
              }, {
                src: 'https://ahorratotal.shop/cdn/shopifycloud/checkout-web/assets/c1/assets/maestro.ByfUQi1c.svg',
                alt: 'Maestro'
              }, {
                src: 'https://ahorratotal.shop/cdn/shopifycloud/checkout-web/assets/c1/assets/mercadopago.BK20nVmQ.svg',
                alt: 'Mercado Pago'
              }].map(method => <div key={method.alt} className="flex items-center justify-center h-8" data-id="element-169">
                    <img src={method.src} alt={method.alt} className="h-7 w-auto object-contain" data-id="element-170" />
                  </div>)}
                <div className="flex items-center justify-center h-8 border border-gray-600/50 rounded-md px-3" data-id="element-171">
                  <span className="text-gray-400 text-[11px] font-body font-semibold uppercase tracking-wide" data-id="element-172">
                    Transferencia bancaria
                  </span>
                </div>
              </div>
            </div>
          </div>
        </SectionReveal>

        {/* Distributors compatibility */}
        <SectionReveal delay={0.2} data-id="element-173">
          <div className="mt-16 text-center" data-id="element-174">
            <div className="inline-flex items-center gap-2 mb-8" data-id="element-175">
              <ZapIcon className="w-5 h-5 text-blue-400" aria-hidden="true" data-id="element-176" />
              <p className="text-lg sm:text-xl text-white font-heading font-bold uppercase tracking-wide m-0" data-id="element-177">
                Compatible con usuarios de estas distribuidoras
              </p>
              <ZapIcon className="w-5 h-5 text-blue-400" aria-hidden="true" data-id="element-178" />
            </div>

            <div className="flex flex-wrap items-center justify-center gap-3 mb-8" data-id="element-179">
              {['Edenor', 'Edesur', 'EDEA', 'EDELAP', 'EPEC', 'EPE Santa Fe', 'EDEMSA', 'ENERSA', 'EDESA'].map(name => <div key={name} className="bg-brand-dark border border-blue-500/15 rounded-lg px-5 py-2.5 text-gray-200 font-body text-sm font-semibold hover:border-blue-500/30 transition-colors" data-id="element-180">
                  {name}
                </div>)}
            </div>

            <p className="text-xs text-gray-600 font-body max-w-lg mx-auto leading-relaxed uppercase tracking-wider" data-id="element-181">
              Guía independiente para usuarios residenciales. No afiliada a
              estas empresas.
            </p>
          </div>
        </SectionReveal>
      </div>
    </section>;
}